<template>
  <main class="main">
    <!--    <div class="score-debug">
      {{ debugScores }}
    </div> -->
    <div class="anim-wrap">
      <div class="container test-container">
        <div
          v-if="testActive"
          class="row"
          :class="{
            selected: selected === true || selected === false,
            out: !showQuestions,
          }"
        >
          <div ref="slider" class="col-md-8 offset-md-2 text-center">
            <div
              class="question-image question-image static"
              :class="{ toggled: selected }"
            >
              <div
                v-if="formattedQuestions[0]"
                :class="{
                  toggled: closedCaptions === true,
                  dark: formattedQuestions[0].scheme === 'dark',
                }"
                class="caption-container"
              >
                {{ formattedQuestions[0].captions[0] }}
              </div>
              <div class="load-bar"></div>
            </div>
            <div></div>
            <div class="picker-container">
              <vue-slider
                :class="{
                  active: itemValue !== null,
                }"
                v-model="itemValue"
                :process="false"
                :data="data"
                :height="12"
                :dragOnClick="true"
                @drag-end="selectAnswer"
                :disabled="!selectionReady"
                tooltip=active
                :useKeyboard="true"
                :adsorb="true"
                :marks="marks"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="info-modal"
      :class="{
        toggled: showInfo === true,
      }"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-6 offset-md-3">
            <div class="text-center test-information">
              <div class="wrap">
                <img src="@/assets/example_item_pathways.png" />
              </div>
              <h3>Information</h3>
              <p>
                Read each question carefully and decide how you would feel about doing each type of work using following options:
                Strongly Dislike, Dislike, Unsure, Like, Strongly Like.
              </p>
              <p>
                Try not to think about if you have enough education or training to do the work or how much money you would make doing the work. Just think about if you would like or dislike doing the work.
              </p>
              <p>There are no right or wrong answers. Please take your time answering the questions. There is no need to rush.</p>
              <div v-if="$hasCompletedPathways()" class="warning">
                After completing the test, the new pathways report will replace your previous report and you won't be able to access the old report.
              </div>
              <button @click="closeInfo" class="btn btn-primary">
                Get started!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loader" :class="{ toggled: loading === true }">
      <div class="wrap">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p>Calculating the profile</p>
    </div>
    <div class="question-controls" :class="{ toggled: testActive === true }">
      <button
        class="tab tab-info"
        v-on:click="showInfo = !showInfo"
        title="Info"
        v-tippy
      >
        <font-awesome-icon icon="info" />
      </button>
      <button
        v-on:click="undoSelection"
        class="tab tab-undo"
        :class="{ unclickable: undoActive === false || answeredQuestions < 1 }"
        title="Undo last selection"
        v-tippy
      >
        <font-awesome-icon icon="undo" />
      </button>
      <button
        class="tab tab-cc"
        title="Closed captions"
        v-tippy
        v-on:click="closedCaptions = !closedCaptions"
        :class="{ toggled: closedCaptions === true }"
      >
        <font-awesome-icon icon="closed-captioning" />
      </button>
    </div>
    <div class="progress-counter" :class="{ toggled: testActive === true }">
      <div
        v-for="index in testLength"
        :key="index"
        :class="{ active: index <= answeredQuestions.length }"
        class="progress-dot"
      ></div>
    </div>
  </main>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import { mapState } from "vuex";
import { pathwaysCards } from "@/assets/pathwaysData.js";
import SVGInjector from "svg-injector";
import createjs from "createjs-cmd";
import VueSlider from "vue-slider-component";

export default {
  name: "TestPathways",
  components: { VueSlider },
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    ...mapState(["friends"]),
    getUser() {
      return this.user ? this.user : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
    getFriends() {
      return this.friends ? this.friends : "";
    },
  },
  data() {
    return {
      pathwaysData: null,
      formattedQuestions: [],
      answeredQuestions: [],
      showQuestions: false,
      loadQueue: false,
      selected: null,
      selectionReady: false,
      loading: false,
      success: false,
      selectionTime: 0,
      selectionClock: null,
      focusActive: false,
      focusTimer: null,
      closedCaptions: true,
      testActive: false,
      undoActive: false,
      testProgress: 0,
      testLength: 0,
      showInfo: true,
      sendCounter: 0,
      itemValue: null,      
      imagePath: "https://cdn.traitstack.com/pathways/",
      data: ["Strongly Dislike", "Dislike", "Unsure", "Like", "Strongly Like"],
      marks: {
        "Strongly Dislike": "😭",
        "Dislike": "😢",
        "Unsure": "😑",
        "Like": "😊",
        "Strongly Like": "😆",
      },
    };
  },
  mounted() {
    this.initTest();
  },
  methods: {
    // Initialise test
    initTest: function() {
      // Init loadQueue
      this.loadQueue = new createjs.LoadQueue(true);
     //this.loadQueue.on("fileload", this.handleFileComplete);

      this.buildQuestions();
      this.preloadImage(0);
      this.preloadImage(1);
    },

    // Build test questions
    buildQuestions() {
      // Add active questions
      this.formattedQuestions = pathwaysCards;
      
      // Populate total length
      this.testLength = this.formattedQuestions.length;
    },

    closeInfo: function() {
      this.showInfo = false;
      if (!this.testActive) {
        this.startTest();
      }
    },

    startTest: function() {
      this.testActive = true;
      setTimeout(() => {
        this.renderImage();
      }, 1000);
    },

    timerStart: function() {
      this.selectionClock = new Date();
    },

    getSelectionTime() {
      let currentTime = new Date().getTime();
      let timeDifference = currentTime - this.selectionClock.getTime();
      let timeDifferenceInSeconds = timeDifference / 1000;
      return timeDifferenceInSeconds;
    },

    // Preload image pair
    preloadImage(orderNumber) {
      this.loadQueue.loadFile({
        src:
          this.imagePath +
          this.formattedQuestions[orderNumber].files[0] +
          ".svg",
        type: createjs.IMAGE,
      });
    },

   /*  // Debug
    handleFileComplete: function(event) {
      //console.log("asset loaded" + event);
    }, */

    // Select answer
    selectAnswer() {
      this.selected = true;
      this.undoActive = false;
      this.setChoiceSelectionTime();
    },

    // Clear selection timer
    clearChoiceSelectionTime: function() {
      this.focusActive = false;
      clearInterval(this.focusTimer);
    },

    // Set selection timer
    setChoiceSelectionTime: function() {
      this.clearChoiceSelectionTime();
      setTimeout(() => {
        this.focusActive = true;
      }, 10);

      this.focusTimer = setInterval(() => {
        this.clearChoiceSelectionTime();
        this.saveSelection();
      }, 1000);
    },

    // Render test image pair
    renderImage() {
      document.querySelectorAll(".injected-svg").forEach((e) => e.remove());

      var questionImage = document.querySelector(".question-image");
      var newImage = document.createElement("img");
      newImage.setAttribute("class", "svg-image");
      newImage.setAttribute(
        "data-src",
        this.imagePath + this.formattedQuestions[0].files[0] + ".svg"
      );
      questionImage.appendChild(newImage);

      var mySVGsToInject = document.querySelectorAll(".svg-image");
      SVGInjector(mySVGsToInject);

      // Preload the third image in the queue
      const imageToPreload = 2;
      if (imageToPreload < this.formattedQuestions.length) {
        this.preloadImage(imageToPreload);
      }

      setTimeout(() => {
        this.timerStart();
        this.selectionReady = true;
        this.showQuestions = true;
      }, 250);
    },

    // Undo selection
    undoSelection() {
      if (!this.undoActive) {
        return false;
      }
      this.undoActive = false;
      this.showQuestions = false;
      setTimeout(() => {
        this.formattedQuestions.unshift(
          this.answeredQuestions[this.answeredQuestions.length - 1]
        );
        this.answeredQuestions.pop();
        this.selected = null;
        this.renderImage();
        this.updateDebugScores();
      }, 750);
    },

    // Save selection
    saveSelection() {
      //this.$refs.slider.focus();
      this.selectionReady = false;
      this.showQuestions = false;
      this.undoActive = false;
      let selectionTime = this.getSelectionTime();

      setTimeout(() => {
        let question = this.formattedQuestions[0];
        question.selection = this.itemValue;
        question.time = selectionTime;
        this.answeredQuestions.push(question);
        this.formattedQuestions.shift();
        this.selected = null;
        this.itemValue = null;

        if (this.formattedQuestions.length > 0) {
          this.renderImage();
          this.updateDebugScores();
        } else {
          this.completeTest();
        }

        setTimeout(() => {
          this.undoActive = true;
        }, 500);
      }, 750);
      //console.log(this.answeredQuestions);
    },

    // Debug scores
    updateDebugScores() {
      this.debugScores = { ope: 0, con: 0, ext: 0, agr: 0, neu: 0 };
      this.answeredQuestions.forEach((question) => {
        let band = question.band;

        if (question.selection) {
          this.debugScores[band]++;
        } else {
          this.debugScores[band]--;
        }
      });
    },

    transformScores() {
      let transformedScores = [];

      this.answeredQuestions.forEach((question) => {
        let value = 3;
        
        if (question.selection === "Strongly Dislike") {
          value = 1;
        } else if (question.selection === "Dislike") {
          value = 2;
        } else if (question.selection === "Unsure") {
          value = 3;
        } else if (question.selection === "Like") {
          value = 4;
        } else if (question.selection === "Strongly Like") {
          value = 5;
        }

        let obj = {
          id: question.id,
          band: question.scale,
          value: value,
          active: question.active,
          time: question.time,
        };
        transformedScores.push(obj);
      });

      return transformedScores;
    },

    // Complete test
    completeTest: function() {
      this.testActive = false;
      this.loading = true;
      const scores = this.transformScores();
      this.sendTestData(scores);
    },

    sendTestData: function(scores) {
      let sendPathwaysScore = firebase
        .functions()
        .httpsCallable("sendPathwaysScore");

      sendPathwaysScore({
        scores: scores,
      })
        .then(() => {
          this.loading = false;
          setTimeout(() => {
            this.$router.replace({ path: "/results/pathways" });
          }, 500);
        })
        .catch((error) => {
          if (this.sendCounter < 2) {
            this.sendCounter++;
            this.sendTestData(scores);
          } else {
            var message = error.message;
            console.log(message);
          }
        });
    },
  },
};
</script>
